<template>
  <div class="sub-page">
    <Header />
    <div class="main">
     <Center />
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '@district/components/common/Header.vue'
import Footer from '@district/components/common/Footer.vue'
import Center from '@daoba-match/components/center/Index.vue'
export default {
  name: 'Home',
  props: {
    
  },
  data () {
    return {

    }
  },
  components: {
    Header,
    Center,
    Footer,
  },
  mounted () {},
  methods: {
    
  },
  watch: {},
}
</script>

<style scoped lang="scss">
.sub-page{
    width: 100%;
    .main{
        margin-top: 100px;
        min-height: 500px;
        background-color: #F0F1F2;
    }
}
</style>



// WEBPACK FOOTER //
// src/district/views/icenter/Home.vue